import type { Plan } from '../../plan/types';

/**
 * Check if a plan is the legacy Developer plan facade.
 * Falls back to false if the property is not set.
 */
export const isDeveloperPlanFacade = (plan: Plan): boolean => {
  return plan.isLegacyDeveloperFacade ?? false;
};
